/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplateStepsControllerUpdateMutationRequest, WorkflowTemplateStepsControllerUpdateMutationResponse, WorkflowTemplateStepsControllerUpdatePathParams, WorkflowTemplateStepsControllerUpdate400, WorkflowTemplateStepsControllerUpdate401, WorkflowTemplateStepsControllerUpdate403, WorkflowTemplateStepsControllerUpdate404 } from "../../models/workflowsController/WorkflowTemplateStepsControllerUpdate";

function getWorkflowTemplateStepsControllerUpdateUrl(id: WorkflowTemplateStepsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/workflow-template-steps/${id}` as const }  
  return res
}

/**
 * @summary Update a workflow template step
 * {@link /api/v1/workflow-template-steps/:id}
 */
export async function workflowTemplateStepsControllerUpdate(id: WorkflowTemplateStepsControllerUpdatePathParams["id"], data?: WorkflowTemplateStepsControllerUpdateMutationRequest, config: Partial<RequestConfig<WorkflowTemplateStepsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowTemplateStepsControllerUpdateMutationResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerUpdate400 | WorkflowTemplateStepsControllerUpdate401 | WorkflowTemplateStepsControllerUpdate403 | WorkflowTemplateStepsControllerUpdate404>, WorkflowTemplateStepsControllerUpdateMutationRequest>({ method : "PATCH", url : getWorkflowTemplateStepsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}